import React from 'react'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LoanDetailSF from '../../../components/superUser/loan/LoanDetailSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const LoanDetailPageUI = ({ context, errorList, loan, account, onRefreshClick,
  copyToClipboardText, onCopyToClipboard,
  onMarkSanctionSigned, enableMarkSanctionSigned, onEnableMarkSanctionSigned,
  markSanctionSignedSubmitted, markSanctionSignedErrorList,
  bankAccountList,
  creditMemoList, selectedCreditMemo, generateCreditMemoRequested,
  onGenerateCreditMemo, onRefreshCreditMemos, onCreditMemoSelect, onStartChat, showChatIframe, onCloseChatIframe,
  showCreditMemoResultModal, creditMemoResultMessage, creditMemoResultType, onCloseCreditMemoResultModal,
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_loan_a_lst'
    backLink={`/su/loans${loan && (loan.status === 'closed' ? '/closed' : (loan.status === 'disbursed' ? '/disbursed' : ''))}`}
    headerText={loan ? (loan.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !bankAccountList || !errorList} loan={loan} page='details' dimension='w768'
  >
    {
      (!loan || !bankAccountList || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && bankAccountList &&
        <LoanDetailSF context={context} loan={loan} account={account}
          copyToClipboardText={copyToClipboardText}
          onCopyToClipboard={onCopyToClipboard}
          onRefreshClick={onRefreshClick}
          onMarkSanctionSigned={onMarkSanctionSigned}
          enableMarkSanctionSigned={enableMarkSanctionSigned}
          onEnableMarkSanctionSigned={onEnableMarkSanctionSigned}
          markSanctionSignedSubmitted={markSanctionSignedSubmitted}
          markSanctionSignedErrorList={markSanctionSignedErrorList}
          bankAccountList={bankAccountList}
          creditMemoList={creditMemoList}
          selectedCreditMemo={selectedCreditMemo}
          generateCreditMemoRequested={generateCreditMemoRequested}
          onGenerateCreditMemo={onGenerateCreditMemo}
          onRefreshCreditMemos={onRefreshCreditMemos}
          onCreditMemoSelect={onCreditMemoSelect}
          onStartChat={onStartChat}
          showChatIframe={showChatIframe}
          onCloseChatIframe={onCloseChatIframe}
          showCreditMemoResultModal={showCreditMemoResultModal}
          creditMemoResultMessage={creditMemoResultMessage}
          creditMemoResultType={creditMemoResultType}
          onCloseCreditMemoResultModal={onCloseCreditMemoResultModal}
        />
    }
  </SuperUserLoanPageSF>

export default LoanDetailPageUI
